import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Импорт файлов перевода
import en from "./locales/en.json";
import ru from "./locales/ru.json";
import az from "./locales/az.json";

i18n
  .use(initReactI18next) // Подключение React
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      az: { translation: az },
    },
    lng: "az", // Язык по умолчанию
    fallbackLng: "az", // Язык по умолчанию, если переводы отсутствуют
    interpolation: {
      escapeValue: false, // React сам экранирует строки
    },
  });

export default i18n;
